export const theme = {
  token: {
    linkDecoration: 'underline',
    primaryColor: '#20C474',
  },
}
